var React = require('react');

function RightArrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: #f1f3fb;\n      }\n    ")),React.createElement("path",{"className":"cls-1","d":"M52.35,91H0C54,42.5,53.5,42.5,0,0H52.35","key":1})]);
}

RightArrow.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 52 91"};

module.exports = RightArrow;

RightArrow.default = RightArrow;
